import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { AuthProvider } from "../src/utils/AuthContext";
import Login from "../src/pages/LoginPage/login";
import Dashboard from "./pages/Dashboard/Dashboard";
import PackageDetails from "./components/PackageDetails/PackageDetails";
import ForgotPasswordPage from "./pages/LoginPage/forgotPassword";
import SetNewPassword from "./pages/LoginPage/setNewPassword";
import CreatePackage from "./pages/Package/CreatePackage";
import UsersListPage from "./pages/UserListPage/UsersListPage";
import NotificationListPage from "./pages/Notifications/NotificationListPage";
import AdminPage from "./components/AdminPage/AdminPage";
import EditProfile from "./components/AdminPage/EditProfile";
import UserPackage from "./components/UserList/UserPackage";
import MyDeliveryPage from "./pages/MyPackages/MyDeliveryPage";
import MyRequestPage from "./pages/MyPackages/MyRequestPage";
import PrivatePolicy from "./pages/PrivatePolicy/PrivatePolicy";
import TermsOfUse from "./pages/PrivatePolicy/TermsOfUse";
import MobileNumberLogin from "./pages/LoginPage/mobileNumberLogin";
import CompleteMobileProfile from "./pages/LoginPage/CompleteMobileProfile";
import ProtectedRoute from "./pages/ProtectedRoute";
import Deeplinking from "./pages/PrivatePolicy/Deeplinking";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/" element={<MobileNumberLogin />} />
          <Route path="/Login" element={<Login />} />
          <Route path="/ForgotPassword" element={<ForgotPasswordPage />} />
          <Route path="/MobileLogin" element={<MobileNumberLogin />} />
          <Route path="/CompleteProfile" element={<CompleteMobileProfile />} />

          <Route path="/dashboard" element={<ProtectedRoute element={<App />} />}>
            <Route index element={<ProtectedRoute element={<Dashboard />} />} />
          </Route>

          <Route
              path="/view/:packagePin"
              element={<ProtectedRoute element={<PackageDetails />} />}
          />
            <Route
              path="/packagedetails/:packagePin"
              element={<ProtectedRoute element={<PackageDetails />} />}
            />

          <Route path="/profile" element={<ProtectedRoute element={<App />} />}>
            <Route index element={<ProtectedRoute element={<AdminPage />} />} />
          </Route>
          <Route path="/editProfile" element={<App />}>
            <Route index element={<ProtectedRoute element={<EditProfile />} />} />
          </Route>

          <Route path="/SetPassword" element={<SetNewPassword />} />
          <Route path="/MyDelivery" element={<ProtectedRoute element={<MyDeliveryPage />} />} />
          <Route path="/MyRequest" element={<ProtectedRoute element={<MyRequestPage />} />} />
          <Route
            path="/create-package"
            element={<ProtectedRoute element={<CreatePackage type="create" />} />}
          />
          <Route
            path="/edit-package/:id"
            element={<ProtectedRoute element={<CreatePackage type="edit" />} />}
          />
          <Route path="/users" element={<ProtectedRoute element={<UsersListPage />} />} />
          <Route path="/notifications" element={<ProtectedRoute element={<NotificationListPage />} />} />
          <Route path="/users/:userId" element={<ProtectedRoute element={<UserPackage />} />} />
          <Route path="/privacypolicy" element={<PrivatePolicy />} />
          <Route path="/deeplinking" element={<Deeplinking />} />
          <Route path="/termsofuse" element={<TermsOfUse />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Router>
    </AuthProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
